import { gql } from "@apollo/client";
import "../../api/types.js";
import { GqlRequestBuilder } from "../../api/GqlRequestBuilder.js";
import "@apollo/client/errors";
import "rxjs";
import "rxjs/operators";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "moment-timezone";
import { nameOf } from "../../utils/object.js";
import "react-intl";
class BackpackRequestBuilder extends GqlRequestBuilder {
  validateFilters(_filter) {
    return;
  }
  buildQuery = (fields) => gql`
        query GetBackpackItems($filter: BackpackItemsFilter, $sort: Sorting, $start: Int, $end: Int) {
            getBackpackItems(filter: $filter, sort: $sort, end: $end, start: $start) {
                items {
                    bonus_id
                    uid @include(if: ${this.hasField(fields, "uid")})
                    marketing_code @include(if: ${this.hasField(fields, "marketing_code")})
                    bonus_name @include(if: ${this.hasField(fields, "bonus_name")})
                    bonus_status @include(if: ${this.hasField(fields, "bonus_status")})
                    created_at @include(if: ${this.hasField(fields, "created_at.seconds")}) {
                        seconds
                    }               
                    serial_number @include(if: ${this.hasField(fields, "serial_number")})
                    used_at @include(if: ${this.hasField(fields, "used_at.seconds")}) {
                        seconds
                    }
                    tool_label @include(if: ${this.hasField(fields, "tool_label")})
                    value @include(if: ${this.hasField(fields, "value")})
                }
                total_count
            }
        }
    `;
  buildFilter(filter) {
    return {
      filter: {
        text: this.getGQLTextFilter(
          Object.keys(this.filterFieldsMapper).map(
            (key) => this.toGQLTextFilter(this.filterFieldsMapper[key], filter[key])
          )
        )
      }
    };
  }
  filterFieldsMapper = {
    uid: [nameOf("uid")]
  };
}
export {
  BackpackRequestBuilder
};
//# sourceMappingURL=requestBuilder.js.map
